import { Link } from "react-router-dom";
import { useDiscord } from "../../context/DiscordContext";

const DiscordIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3l-.224.388a17.93 17.93 0 0 0-8.668 0L7.442 3a19.79 19.79 0 0 0-3.76 1.369C1.43 8.043.787 11.62 1.085 15.146a19.86 19.86 0 0 0 5.928 3.014 14.6 14.6 0 0 0 1.265-2.058 12.81 12.81 0 0 1-2.005-.96c.168-.122.333-.249.493-.378a14.18 14.18 0 0 0 12.468 0c.16.13.325.256.493.378-.643.382-1.318.706-2.008.962.376.738.802 1.43 1.268 2.058a19.83 19.83 0 0 0 5.928-3.014c.41-4.18-.611-7.708-2.598-10.78ZM8.683 13.36c-1.182 0-2.156-1.085-2.156-2.421 0-1.336.953-2.422 2.156-2.422 1.21 0 2.176 1.094 2.156 2.422 0 1.336-.953 2.421-2.156 2.421Zm6.634 0c-1.182 0-2.156-1.085-2.156-2.421 0-1.336.953-2.422 2.156-2.422 1.21 0 2.176 1.094 2.156 2.422 0 1.336-.946 2.421-2.156 2.421Z" />
  </svg>
);

export default function DiscordButton({ compact = false }) {
  const { connect, disconnect, isConnected, user } = useDiscord();

  if (isConnected) {
    return (
      <div className="flex items-center gap-2" data-testid="discord-connected-pill">
        <Link
          to="/members/me"
          data-testid="my-character-link"
          className="hidden xl:inline-flex items-center border border-[#C0A875] text-[#C0A875] hover:bg-[#C0A875]/15 px-4 py-2 font-mono-ui text-[11px] uppercase tracking-[0.2em] transition-colors whitespace-nowrap"
        >
          My Character
        </Link>
        <div className="flex items-center gap-3 pl-4 pr-6 py-2 border border-[#283524] bg-[#161D14]">
          {user?.avatar ? (
            <img src={user.avatar} alt="" className="w-5 h-5 rounded-full" />
          ) : (
            <span className="w-2 h-2 bg-[#C0A875] pulse-dot" />
          )}
          <span className="font-mono-ui text-xs uppercase tracking-widest text-[#E2E4DF] whitespace-nowrap">
            {user?.global_name || user?.username}
          </span>
        </div>
        <button
          data-testid="discord-disconnect-button"
          onClick={disconnect}
          className="font-mono-ui text-[10px] uppercase tracking-widest text-[#8D9A87] hover:text-[#E2E4DF] px-2 whitespace-nowrap"
        >
          Disconnect
        </button>
      </div>
    );
  }

  return (
    <button
      data-testid="discord-connect-button"
      onClick={connect}
      className={`bg-[#5865F2] hover:bg-[#4752C4] text-white inline-flex items-center gap-2 ${
        compact ? "px-4 py-2 text-[11px]" : "px-6 py-3 text-xs"
      } uppercase font-mono-ui tracking-widest transition-colors`}
    >
      <DiscordIcon />
      Connect Discord
    </button>
  );
}
